import { useEffect } from "react";
import { MdErrorOutline, MdEmail } from "react-icons/md";
import { FaRedo } from "react-icons/fa";

const ServerError = () => {
    const supportEmail = "support@1digitalstack.ai";

    useEffect(() => {
        document.title = `Server Error | REVINITI`;
    }, []);

    const handleReload = () => {
        window.location.href = "/";
    };

    const handleContactSupport = () => {
        const subject = encodeURIComponent("REVINITI - Server Error (500)");
        const body = encodeURIComponent(
            `Hello Support Team,\n\nI encountered a server error while trying to access REVINITI.\n\nError Details:\n- Error Code: 500 - Internal Server Error\n- Time: ${new Date().toLocaleString()}\n- URL: ${
                window.location.href
            }\n- Browser: ${
                navigator.userAgent
            }\n\nPlease help me resolve this issue.\n\nThank you.`
        );
        window.location.href = `mailto:${supportEmail}?subject=${subject}&body=${body}`;
    };

    return (
        <div className="page-not-found pt-5">
            <div className="card bg-light shadow">
                <h2>
                    <MdErrorOutline />
                </h2>
                <h3 className="mt-4">Oops! Something Went Wrong</h3>
                <h5>
                    We're sorry, but we encountered an error while trying to
                    load the application. This could be due to a temporary issue
                    with our servers or your internet connection. Please try
                    reloading the page or contact support if the problem
                    persists.
                </h5>
                <div className="mt-5 d-flex flex-column flex-md-row gap-3 justify-content-center align-items-center">
                    <button onClick={handleReload} className="btn btn-primary">
                        <div className="d-flex align-items-center gap-2">
                            <FaRedo /> Reload Page
                        </div>
                    </button>
                    <button
                        onClick={handleContactSupport}
                        className="btn btn-outline-secondary"
                    >
                        <div className="d-flex align-items-center gap-2">
                            <MdEmail /> Contact Support
                        </div>
                    </button>
                </div>
                <div className="mt-4">
                    <p className="text-muted mb-1 small">
                        Need help? Email us at{" "}
                        <a
                            href={`mailto:${supportEmail}`}
                            className="text-decoration-none"
                        >
                            {supportEmail}
                        </a>
                    </p>
                    <small className="text-muted">
                        Error Code: 500 - Internal Server Error
                    </small>
                </div>
            </div>
        </div>
    );
};

export default ServerError;
